<cll-card
    @fade
    appearance="elevated"
    class="auth-form-card">
    <div class="card-content">
        <div class="auth-card__title"
             data-testid="title:auth-card">
            {{ title }}
        </div>

        <div class="auth-card__sub-title"
             data-testid="subtitle:auth-card">
            {{ subTitle }}
        </div>

        <ng-content />
    </div>
</cll-card>
